module.exports = __webpack_public_path__ + "static/media/lumenlife-1.344a4f45.jpg";